<template>
  <div class="about">
    <section class="banner_area">
        <div class="banner_inner d-flex align-items-center">
            <div class="overlay bg-parallax" data-stellar-ratio="0.9" data-stellar-vertical-offset="0" data-background=""></div>
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-lg-8 text-center">
                  <div class="main_title">
                    <h2>Privacy Policy</h2>
                    <p data-aos="fade-up" style="color: black; text-align: left;">Privacy is a fundamental human right. At GitLeaf, it’s also one of our core values. Your devices are important to so many parts of your life. What you share from those experiences, and who you share it with, should be up to you. We design GitLeaf products to protect your privacy and give you control over your information. It’s not always easy. But that’s the kind of innovation we believe in.</p>
                    <hr>
                    <h2 data-aos="fade-up">Terms of Service</h2>
                    <ul data-aos="fade-up">
                      <li>
                        <p style="color: black; text-align: left;">
                        The Intellectual Property disclosure will inform users that the contents, logo and other visual media you created is your property and is protected by copyright laws.</p><br>
                      </li>
                      <li>
                        <p style="color: black; text-align: left;">
                        A Termination clause will inform that users' accounts on your website and mobile app or users' access to your website and mobile (if users can't have an account with you) can be terminated in case of abuses or at your sole discretion.</p><br>
                      </li>
                      <li>
                        <p style="color: black; text-align: left;">
                        A Governing Law will inform users which laws govern the agreement. This should the country in which your company is headquartered or the country from which you operate your website and mobile app.</p>
                      </li>
                    </ul>

                    <!-- A Links To Other Web Sites clause will inform users that you are not responsible for any third party websites that you link to. This kind of clause will generally inform users that they are responsible for reading and agreeing (or disagreeing) with the Terms and Conditions or Privacy Policies of these third parties.

                    If your website or mobile app allows users to create content and make that content public to other users, a Content section will inform users that they own the rights to the content they have created. The "Content" clause usually mentions that users must give you (the website or mobile app developer) a license so that you can share this content on your website/mobile app and to make it available to other users.

                    Because the content created by users is public to other users, a DMCA notice clause (or Copyright Infringement ) section is helpful to inform users and copyright authors that, if any content is found to be a copyright infringement, you will respond to any DMCA takedown notices received and you will take down the content.

                    A Limit What Users Can Do clause can inform users that by agreeing to use your service, they're also agreeing to not do certain things. This can be part of a very long and thorough list in your Terms and Conditions agreements so as to encompass the most amount of negative uses. -->
                  </div>
                </div>
              </div>
            </div>
        </div>
    </section>

  <Footer/>

  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Footer
  }
};
</script>